import type { JSX } from 'react';
import type { CmsData } from '../../../../interfaces/webapp_json';
import { ComponentRecognizer } from '../../ComponentRecognizer/ComponentRecognizer';
import type { FooterBlockType } from '../types';

type BlockContentProps = {
  data: CmsData;
};

export enum BlockContentTestIds {
  main = 'block-content',
  headline = 'block-content-headline',
  noRenderComponentFound = 'block-content-no-component-found',
}

export const BlockContent = ({ data }: BlockContentProps): JSX.Element => {
  const comp = (data.paragraph as FooterBlockType[])
    ?.filter((item) => item.parent_field_name === 'field_footer')
    ?.map((item, index) => {
      const { field_headline: headline } = item;
      const customKeyMain = `main-${index}`;
      const customKeyHeadline = `headline-${index}`;

      return (
        <div
          className="[&_a]:text-color-text text-size-body-sm mb-4.5 inline-block w-xs align-top [&_a]:no-underline"
          key={customKeyMain}
        >
          {headline && (
            <div
              className="mb-1.5 font-semibold"
              data-testid={BlockContentTestIds.headline}
              key={customKeyHeadline}
            >
              {headline}
            </div>
          )}
          <ComponentRecognizer item={item} />
        </div>
      );
    });

  if (comp.length > 0) {
    return (
      <div
        className="shop-content flex flex-row flex-wrap items-stretch p-0 pt-[4.25rem] [&>div]:m-0 [&>div]:mb-4.5 [&>div]:box-border [&>div]:basis-[calc(100%/4)] [&>div]:p-0"
        data-testid={BlockContentTestIds.main}
      >
        {comp}
      </div>
    );
  }

  return <div data-testid={BlockContentTestIds.noRenderComponentFound} />;
};
